export default {
  ResetPasswordPage: {
    label: {
      email: 'Your Email',
    },
    btn: {
      submit: 'Reset password',
    },
  },
  ConfirmationModal: 'A confirmation email has been sent to your email',
};
